export const LOGIN_CHANNEL = {
  EB_INTRO: 1,
  EB: 2,
  DINGDANG: 3,
};

export const LOGIN_STATUS = {
  NO_LOGIN: 0,
  LOGIN: 1,
  SUCCESS: 2,
  FAIL: 3,
  KICK_OFF: 4,
};



// WEBPACK FOOTER //
// ./consts/account.js